import { Button, Input, WidgetDropDownObjects, } from '@yellowcard/components-library-vue3';
import { computed, defineComponent, ref, watch } from 'vue';
import { useKycStore } from '@/store/modules/kyc';
import { useAuthStore } from '@/store/modules/auth';
import { storeToRefs } from 'pinia';
import { KycTypes } from '@/types/kyc';
import validator from 'validator';
import { MIXPANEL_EVENTS, trackEvent } from '@/utils/mixpanel';
import useTransactionsStore from '@/store/modules/transactions';
export default defineComponent({
    name: 'SelectIdCard',
    props: {},
    components: {
        Button,
        Input,
        WidgetDropDownObjects,
    },
    setup() {
        const authStore = useAuthStore();
        const { partnerId } = storeToRefs(authStore);
        const kycStore = useKycStore();
        const { currentStep, idType } = storeToRefs(kycStore);
        const transactionStore = useTransactionsStore();
        const { countryConfig, activeSupportedCountryConfig } = storeToRefs(transactionStore);
        const { country } = countryConfig.value;
        const rules = computed(() => ({
            // remove error messages while confirming correct error state
            idType: (value) => {
                if (validator.isEmpty(value || ''))
                    return ' ';
                return true;
            },
        }));
        const defaultValue = computed(() => {
            if (idType.value === '') {
                return undefined;
            }
            return { value: idType.value, label: idType.value };
        });
        const isButtonDisabled = ref(!(rules.value.idType(idType.value) === true));
        const backClick = () => {
            currentStep.value = KycTypes.KycSteps.KYC_5;
        };
        watch(idType, newInput => {
            isButtonDisabled.value = !(rules.value.idType(newInput) === true);
        });
        const proceed = () => {
            trackEvent(MIXPANEL_EVENTS.KYC.NATIONALITY, {
                id_type: idType.value,
                partner: partnerId.value,
            });
            currentStep.value = KycTypes.KycSteps.KYC_7;
        };
        function getIdOptions() {
            return activeSupportedCountryConfig.value?.idTypes ?? [];
        }
        const idTypeSelect = (value) => {
            idType.value = value || '';
        };
        const onKeyPress = () => {
            console.log('key pressed');
        };
        return {
            backClick,
            rules,
            proceed,
            isButtonDisabled,
            idType,
            onKeyPress,
            idTypeSelect,
            defaultValue,
            getIdOptions,
            activeSupportedCountryConfig,
            country,
        };
    },
});
